<template>
  <div style="background-color: white;padding: 16px;">
    <h2 class="mb-3">Email Recipients</h2>
    <div>
      <vue-good-table :columns="columns" :rows="recipients">
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.label === 'Delete'">
            <div
              style="width: 20px; height: 20px; cursor: pointer"
              @click="$emit('on-delete-recipient', props.row)"
            >
              <img src="../../../assets/icons/trash-icon.svg" alt="Delete" />
            </div>
          </span>
          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>
      </vue-good-table>
    </div>
  </div>
</template>

<script>
import {VueGoodTable} from 'vue-good-table';
import {format} from 'date-fns';
import UtcToTimezone from '../../../helpers/UtcToTimezone';

export default {
  props: ['recipients'],
  components: {
    VueGoodTable,
  },
  computed: {
    columns() {
      return [
        {
          label: 'Type',
          field: 'type',
          tdClass: 'text-capitalize',
        },
        {label: 'Email', field: 'email'},
        {
          label: 'Created By',
          field: 'createdBy',
          field: (props) =>
            props.createdBy.firstName + ' ' + props.createdBy.lastName,
        },
        {
          label: 'Created At',
          field: (props) =>
            format(
              UtcToTimezone(props.createdAt, 'yyyy-MM-dd HH:mm:ss'),
              'DD MMM YYYY h:mm A'
            ),
          type: 'text',
        },
        {
          label: 'Delete',
          field: 'id',
          type: 'text',
        },
      ];
    },
  },
};
</script>

<style>
.text-capitalize {
  text-transform: capitalize;
}
</style>
